export default "<p>\n  photo-upload works!\n</p>\n";